import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {LuLayoutDashboard} from "react-icons/lu";
import API from "../../Services/API";
import {toast} from "react-toastify";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {CgPlayListCheck} from "react-icons/cg";
import { saveAs } from 'file-saver';
import Select from "react-select";

const currencyFormat = Intl.NumberFormat('en-US');


function ProductProductionReport() {
    const [basics, setBasics] = React.useState([]);
    const [products, setProducts] = React.useState([]);
    const [status, setStatus] = React.useState( 0);
    const [selectOptions, setSelectOptions] = React.useState([]);
    const [selectedOptions, setSelectedOptions] = React.useState([]);
    const [dateFrom, setDateFrom] = React.useState( null);
    const [dateTo, setDateTo] = React.useState( null);

    const [ampType, setAmpType] = React.useState('');
    const [brand, setBrand] = React.useState('');

    const [group, setGroup] = React.useState('');
    const [total, setTotal] = React.useState( 0);
    const [users, setUsers] = React.useState([]);
    const [user, setUser] = React.useState(0);

    const [isLoaded, setIsLoaded] = React.useState(false);


    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }
        let params = {
            count: 200,
            page: 1,
            list: 1,
            orderBy: 'created_at',
            orderType: 'desc',
            processFor: 'Sales',
            'group_id' : 2
        }
        API.getBasics(params)
            .then((response) => {
                setBasics(response.data)
                API.getUsers(params)
                    .then((response) => {
                        setUsers(response.data);
                        API.getVendors(params)
                            .then((response) => {
                                setIsLoaded(true)
                                const vendors = response.data;
                                let options = [];
                                for (let data in vendors) {

                                    options.push({
                                        value: vendors[data].id,
                                        label: vendors[data].title + " - " + vendors[data].city,
                                    })
                                }
                                setSelectOptions(options)


                            })
                            .catch((error) => {
                                if (error.response) {
                                    toast.error(error.response.data.message);
                                } else {
                                    toast.error(error.message);
                                }
                            });
                    })
            })
            .catch((error) => {

            });

    }, []);

    const onGetReport = (excel = 0) => {
        const fromMonth = dateFrom?.toDate?.().getMonth() -(-1);
        const  toMonth = dateTo?.toDate?.().getMonth() -(-1);

        let params = {
            count: 100,
            page: 1,
            list: 0,
            orderBy: 'created_at',
            orderType: 'desc',
            status_id: status > 0 ? status : null,
            user_id: user,
            brand_id: brand,
            group_id: group,
            amperage: ampType,
            vendor_id: selectedOptions,
            excel,
            created_at_from: typeof dateFrom?.toDate?.().getFullYear() !== "undefined" ? dateFrom?.toDate?.().getFullYear() + '-' + fromMonth + '-' +dateFrom?.toDate?.().getDate() + ' 00:00' : '',
            created_at_to: typeof dateTo?.toDate?.().getFullYear() !== "undefined" ? dateTo?.toDate?.().getFullYear() + '-' + toMonth + '-' + dateTo?.toDate?.().getDate() + ' 23:59': '',

        }

        setIsLoaded(false)
        if (!excel) {
            API.getProductProductionReport(params)
                .then((response) => {
                    setIsLoaded(true)
                    // console.log(response.data[0].data)

                    setProducts(response.data)
                    setTotal(response.meta.total)


                })
                .catch((error) => {
                    setIsLoaded(true)
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }
        else {
            API.getProductProductionReportExcel(params)
                .then((response) => {
                    setIsLoaded(true);
                   const outputFilename = `ngkh${Date.now()}.xlsx`;

                    const blob = new Blob([response.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    });

      /*              const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', outputFilename);
                    document.body.appendChild(link);
                    link.click();*/
                    saveAs(blob, outputFilename);


                })
                .catch((error) => {
                    setIsLoaded(true)
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }
    }

    return (
        <React.Fragment>
            <Header/>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Navbar page="status"/>

            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <LuLayoutDashboard className='ms-2' />
                    گزارش روند تولید باتری ها
                    </h1>
                </div>

                <section className="section dashboard">
                    <div className="row rtl">
                        <div className="col-12">
                            <div className="card info-card sales-card">
                                <div className="card-body rtl">
                                    <h5 className="card-title text-primary">فیلترها <span>|    پارامترهای مورد نظر برای گزارش را انتخاب کنید</span>
                                    </h5>
                                    <div className="row filter-box mb-5 pb-2 rounded text-small-2">
                                        <div className="col-md-3 ">
                                            <label htmlFor="floatingInput" className="mb-2 text-muted text-small-3">
                                                وضعیت
                                            </label>
                                            <select
                                                className={status > 0 ? "form-control text-center text-small-1" : "form-control text-center text-small-1 border-danger"}
                                                id="floatingInput"

                                                value={status}
                                                onChange={(val) => {

                                                    setStatus(
                                                        val.target.value === 'x' ? null : val.target.value
                                                    )
                                                }}
                                            >

                                                <option  value='0'>
                                                    وضعیت را انتخاب کنید
                                                </option>
                                                <option value='1'>
                                                    ثبت اولیه
                                                </option>
                                                <option value='2'>
                                                    تزریق پلاستیک
                                                </option>
                                                <option value='3'>
                                                    مونتاژ
                                                </option>
                                                <option value='4'>
                                                    شستشو
                                                </option>
                                                <option value='5'>
                                                    شارژینگ
                                                </option>
                                                <option value='6'>
                                                    بسته بندی
                                                </option>
                                                <option value='7'>
                                                    آماده ارسال
                                                </option>
                                                <option value='8'>
                                                    گارانتی فعال
                                                </option>
                                                <option value='9'>
                                                    گارانتی فعال - ثبت شده
                                                </option>
                                                <option value='10'>
                                                    مرجوعی
                                                </option>

                                            </select>
                                        </div>
                                        <div className="col-md-3  mt-3">
                                            <Select
                                                options={selectOptions}
                                                placeholder="نماینده فروش"
                                                value={selectedOptions}
                                                isSearchable={true}
                                                onChange={
                                                    (event) => {
                                                        setSelectedOptions(event)
                                                    }
                                                }
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="floatingInput" className="mb-2 text-muted text-small-3">
                                                آمپراژ
                                            </label>
                                            <select
                                                className="form-control text-center text-small-1"
                                                id="floatingInput"
                                                value={ampType}
                                                onChange={
                                                    (event) => {
                                                        setAmpType(event.target.value)
                                                    }
                                                }
                                            >
                                                <option value="0">
                                                    انتخاب آمپراژ
                                                </option>
                                                {
                                                    basics?.amperages?.map(bt => {
                                                        return (
                                                            <option value={bt.title} key={bt.title}>
                                                                {bt.title}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                        <div className="col-md-3 ">
                                            <label htmlFor="floatingInput" className="mb-2 text-muted text-small-3">
                                                برند
                                            </label>
                                            <select
                                                className="form-control text-center text-small-1"
                                                id="floatingInput"

                                                value={brand}
                                                onChange={
                                                    (event) => {
                                                        setBrand(event.target.value)
                                                    }
                                                }
                                            >
                                                <option value="0">
                                                    انتخاب برند
                                                </option>
                                                {
                                                    basics?.brands?.map(bt => {
                                                        return (
                                                            <option value={bt.id} key={bt.id}>
                                                                {bt.name}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                        <div className="col-md-3 mt-3">
                                            <label htmlFor="floatingInput" className="mb-2 text-muted text-small-3">
                                                گروه
                                            </label>
                                            <select
                                                className="form-control text-center text-small-1"
                                                id="floatingInput"

                                                value={group}
                                                onChange={
                                                    (event) => {
                                                        setGroup(event.target.value)
                                                    }
                                                }
                                            >
                                                <option value="0">
                                                    انتخاب گروه باتری
                                                </option>
                                                <option value="1">خودرویی</option>
                                                <option value="2">موتوری</option>
                                            </select>
                                        </div>
                                        <div className="col-md-3  mt-3  ">
                                            <label htmlFor="floatingInput" className="mb-2 text-muted text-small-3">
                                                اپراتور
                                            </label>
                                            <select className="form-control text-center text-small-1"
                                                    aria-label="Default select"
                                                    onChange={(val) => {
                                                        setUser(val.target.value)
                                                    }}
                                            >
                                                <option value="0">
                                                    انتخاب کاربر
                                                </option>
                                                {
                                                    users?.map(d => {
                                                        return (
                                                            <option value={d.id} key={d.id}>
                                                                {
                                                                    d.name
                                                                }
                                                                -
                                                                {
                                                                    d.surname
                                                                }
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>

                                        <div className="col-md-3  text-start mt-5">
                                        <span className='float-end mt-2'>
                                            از تاریخ:
                                        </span>
                                            <DatePicker

                                                onChange={(val) => {
                                                    setDateFrom(val)

                                                }}
                                                calendar={persian}
                                                locale={persian_fa}
                                                calendarPosition="bottom-right"
                                                className="rmdp-mobile"
                                                //value={this.state.date_from}

                                            />

                                        </div>
                                        <div className="col-md-3 text-start mt-5">
                                        <span className='float-end mt-2'>
                                             تا تاریخ:
                                        </span>
                                            <DatePicker
                                                //value={this.state.date_to}
                                                onChange={(val) => {
                                                    setDateTo(val)

                                                }}
                                                calendar={persian}
                                                locale={persian_fa}
                                                calendarPosition="bottom-right"
                                                className="rmdp-mobile"

                                            />
                                        </div>


                                        <div className='col-md-4 mt-5'>
                                            &nbsp;
                                        </div>


                                        <div className='col-md-4 mt-5'>
                                            <button className='btn btn-success w-100 mt-4 text-small-1'
                                                    onClick={() => {
                                                        onGetReport(0)
                                                    }}
                                            >
                                                نمایش گزارش
                                            </button>
                                        </div>
                                        <div className='col-md-4 mt-5'>
                                            <button className='btn btn-primary w-100 mt-4 text-small-1'
                                                    onClick={() => {
                                                        onGetReport(1)
                                                    }}
                                            >
                                                دریافت اکسل
                                            </button>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                        {
                            products.length > 0 &&

                            <div className="col-12">
                                <div className="card info-card sales-card">
                                    <div className="card-body rtl">
                                        <h5 className="card-title text-dark">باتری ها <span> |
                                        شما در حال مشاهده ۱۰۰ باتری اول هستید،‌در صورت نیاز به همه باتری ها دریافت اکسل را بزنید
                                    </span>
                                        </h5>
                                        <div className="row mb-3 pb-2 border-bottom ">
                                        <div
                                                className="col-6 text-end fw-bold text-small-2 pe-3 text-primary opacity-75">
                                                <CgPlayListCheck className='ms-2 text-big-4'/>
                                                تعداد کل باتری ها:
                                                &nbsp;
                                                {currencyFormat.format(total)}

                                            </div>

                                        </div>
                                        <table className="table table-striped">
                                            <thead>
                                            <tr className='text-small-2 text-muted'>
                                                <th scope="col" className='bg-success-subtle rounded-end-3'>#</th>
                                                <th scope="col" className='bg-success-subtle'>کد</th>
                                                <th scope="col" className='bg-success-subtle'>برند</th>
                                                <th scope="col" className='bg-success-subtle'>آمپراژ</th>
                                                <th scope="col" className='bg-success-subtle'>اپراتور</th>
                                                <th scope="col" className='bg-success-subtle'>مشتری</th>
                                                <th scope="col" className='bg-success-subtle'>تاریخ</th>
                                                <th scope="col" className='bg-success-subtle'>نماینده</th>
                                                <th scope="col" className='bg-success-subtle'>کاربرد</th>
                                                <th scope="col" className='bg-success-subtle'>شروع گارانتی</th>
                                                <th scope="col" className='bg-success-subtle'>پایان گارانتی</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                products?.map((product, index) => {
                                                    return (
                                                        <tr key={product.id}
                                                            role='button'
                                                        >
                                                            <th scope="row">
                                                                {(index + 1)}
                                                            </th>
                                                        <td>
                                                            {product.code}

                                                        </td>
                                                        <td>
                                                            {product.brand}

                                                        </td>
                                                        <td>
                                                            {product.amperage}
                                                        </td>
                                                        <td className='text-small-2'>
                                                            {product.status?.operator}
                                                        </td>
                                                        <td className='text-small-2'>
                                                            <a href={'tel:' + product.customer?.mobile}>
                                                                {product.customer?.surname} -
                                                                {product.customer?.mobile}
                                                            </a>
                                                        </td>
                                                        <td>
                                                            {product.status?.date}
                                                        </td>
                                                        <td>
                                                            {product.vendor}
                                                        </td>
                                                        <td>
                                                            {product.usage}
                                                        </td>
                                                        <td>
                                                            {product.start}
                                                        </td>
                                                        <td>
                                                            {product.end}
                                                        </td>

                                                    </tr>
                                                )
                                            })
                                        }
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default ProductProductionReport;